import { Ic, icons } from "../../components/Icons";
import useReveal from "../../components/useReveal";

const pillars = [
  {
    icon: icons.lock,
    title: "Encryption",
    items: [
      "AES-256 encryption at rest on all stored data",
      "TLS 1.3 for all data in transit",
      "Encrypted backups with independent key management",
      "Database-level column encryption for PII",
    ],
  },
  {
    icon: icons.shield,
    title: "Access Control",
    items: [
      "Role-based access control (RBAC) throughout",
      "Zero-trust internal network architecture",
      "MFA enforced for all team members",
      "Principle of least privilege on all service accounts",
    ],
  },
  {
    icon: icons.eye,
    title: "Monitoring",
    items: [
      "24/7 automated threat detection and alerting",
      "Immutable audit logs retained for 12 months",
      "Real-time anomaly detection on API usage",
      "Automated dependency vulnerability scanning",
    ],
  },
  {
    icon: icons.zap,
    title: "Infrastructure",
    items: [
      "Hosted on AWS with SOC 2 Type II certified data centres",
      "Data residency in US — EU residency available on Enterprise",
      "99.9% SLA uptime guaranteed on Pro and Enterprise",
      "Automated daily backups with 30-day retention",
    ],
  },
];

export default function SecurityPage() {
  useReveal();
  return (
    <div style={{background:"var(--bg-primary)",paddingTop:80}}>
      <section className="section section-dark" style={{paddingBottom:40}}>
        <div className="container" style={{textAlign:"center"}}>
          <div className="reveal eyebrow">Security</div>
          <h1 className="reveal headline" style={{marginBottom:16}}>Built secure by default.</h1>
          <p className="reveal subhead" style={{maxWidth:520,margin:"0 auto"}}>
            Your designs and images are yours. We engineer every layer of Ateno to keep them that way.
          </p>
        </div>
      </section>

      <section className="section section-dark" style={{paddingTop:0}}>
        <div className="container">
          <div className="grid-2">
            {pillars.map((p, i) => (
              <div key={i} className={`reveal reveal-d${i+1} card-dark`} style={{padding:"36px 32px"}}>
                <div className="feat-icon-wrap" style={{marginBottom:20}}>
                  <Ic d={p.icon} size={20} color="rgba(167,139,250,.88)"/>
                </div>
                <div style={{fontSize:18,fontWeight:700,color:"var(--text-primary)",letterSpacing:"-.02em",marginBottom:18}}>{p.title}</div>
                <div style={{display:"flex",flexDirection:"column",gap:10}}>
                  {p.items.map((item, j) => (
                    <div key={j} style={{display:"flex",alignItems:"flex-start",gap:10}}>
                      <Ic d={icons.check} size={13} color="#a78bfa" sw={2.5}/>
                      <span style={{fontSize:14,color:"var(--text-secondary)",lineHeight:1.55}}>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="reveal card-dark" style={{marginTop:12,padding:"36px 32px",display:"flex",alignItems:"center",gap:32,flexWrap:"wrap"}}>
            <div style={{flex:1,minWidth:240}}>
              <div style={{fontSize:13,fontWeight:600,letterSpacing:".05em",textTransform:"uppercase",color:"#818cf8",marginBottom:8}}>Responsible Disclosure</div>
              <h3 style={{fontSize:20,fontWeight:700,color:"var(--text-primary)",letterSpacing:"-.02em",marginBottom:8}}>Found a vulnerability?</h3>
              <p style={{fontSize:14,color:"var(--text-tertiary)",lineHeight:1.65}}>We welcome responsible disclosure from security researchers. Send findings to our security team with the information needed to reproduce the issue.</p>
            </div>
            <a href="mailto:info@ateno.co" className="btn btn-outline btn-md" style={{flexShrink:0}}>IN@ateno.co</a>
          </div>
        </div>
      </section>
    </div>
  );
}
